const _ = require('lodash');

exports.createDemoData = (app) => {
    const services = _.mapValues(app.selectedVerticals, _.first);

    if (_.size(app.selectedVerticals.Accounting)) {
        services.Demo = app.selectedVerticals.Accounting[0];
    }

    return {
        services,
        vertical: app.industry || 'financial',
        presentedBy: app.presentedBy && { name: app.presentedBy.name },
        role: app.presentingRole,
        selectedVerticals: app.selectedVerticals
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/js/utils.js
// module id = 22
// module chunks = 0